import React, { memo } from 'react';
import { health } from '../services/core-data';
import useLoader from '../services/use-loader';

export default memo(function HealthLoader(props) {
  const { error, loaded } = useLoader(health, {
    minimumTime: 3000
  });

  if (loaded) {
    return props.children(props);
  }

  return (
    <div className={`health-loading ${error ? 'health-loading-message' : 'coin-flip'}`}>
      {
        error ? 'Error occurred, please contact system support' : (
          <React.Fragment>
            <div className="coin-tails">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/US_One_Cent_Rev.png/240px-US_One_Cent_Rev.png" />
            </div>
            <div className="coin-heads">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/US_One_Cent_Obv.png/240px-US_One_Cent_Obv.png" />
            </div>
          </React.Fragment>
        )
      }
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/app/health-loader.js